import React from 'react'

import { Button, Col, Form } from '_zari/core'

import { Select2Glosa } from 'sharedComponents/select2'

import { KeyEventUtil } from 'utils'

const GlosaFormGroup = ({ setFieldValue, iValue }) => {
  const onChange = React.useCallback(
    salida => {
      if (salida) {
        setFieldValue('_idGlosa', salida.value)
        setFieldValue('glosa', salida.label)
      } else {
        setFieldValue('_idGlosa', '')
        setFieldValue('glosa', '')
      }
    },
    [setFieldValue]
  )

  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('input-modalavanz-importeDebe', e, {
      preventDefault: false
    })
  }, [])

  const clickClear = React.useCallback(() => {
    setFieldValue('_idGlosa', '')
    setFieldValue('glosa', '')

    setTimeout(() => {
      KeyEventUtil.leaveOnKeyEvent('select-modalavanz-glosa')
    }, 200)
  }, [setFieldValue])

  return (
    <Form.Group>
      <Form.Label text='GLOSA' htmlFor='select-modalavanz-glosa' md={12} />
      <Col md={12}>
        {iValue ? (
          <Form.InputGroup>
            <Form.InputText
              disabled
              id='input-glosa'
              name='input-glosa'
              tabIndex={-1}
              defaultValue={iValue}
            />
            <Form.InputGroup.Append>
              <Button onClick={clickClear}>&#120;</Button>
            </Form.InputGroup.Append>
          </Form.InputGroup>
        ) : (
          <Select2Glosa id='select-modalavanz-glosa' onChange={onChange} onKeyDown={onKeyDown} />
        )}
      </Col>
    </Form.Group>
  )
}

export default React.memo(GlosaFormGroup)
